import { CxEvent } from '@spartacus/core';

export class GtmGgCategoryPageEvent extends CxEvent {
  event?: string;
  list?: string;
  ecommerce?: {
    impressions?: {
      name?: string;
      price?: string;
      list?: string;
      position?: string;
      id?: string;
      brand?: string;
    }[];
  };
}
